import React, {  useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo.png";

import Aboutus from "./staticContent/Aboutus";
import GeneralTerms from "./staticContent/GeneralTerms";
import Kyc from "./staticContent/Kyc";
import PrivacyPolicy from "./staticContent/PrivacyPolicy";
import RulesRegulation from "./staticContent/RulesRegulation";
import ResponsibleGaming from "./staticContent/ResponsibleGaming";
import AuthContext from "../context/AuthContext";
import Tab from "./socialTab/tab";


const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className={isReadMore ? "text full-text" : "text "}>
      {isReadMore ? text.slice(0, 300) : text}
      <span
        onClick={toggleReadMore}
        className="read-or-hide"
        style={{ color: "black" }}
      >
        {isReadMore ? "Show More" : " Show Less"}
      </span>
    </p>
  );
};

const FooterSection = () => {
  let { open, setOpen, content, slug, setSlug, handleContentToggle } =
    useContext(AuthContext);
  const { t } = useTranslation();
  const [showImg, setShowImg] = useState(true);
  const navigate = useNavigate();
  

  return (
    <>
      <div className="newcssadd " style={{ paddingBottom: '50px' }}>
        <div className="mian-wrap" style={{ paddingBottom: '0' }}>
          <div id="supportWrap" className="support-wrap" style={{ marginBottom: '20px' }}>
             <Tab/>
          </div>
          <footer className="cls_footer_new_marq">
            <img id="legal-image" src="/assets/images/payment/LEGAL.png" alt="logo-footer" />
            <marquee className="marquee">
                <ul className="marquee-content">
                  <li className="marquee-item">
                      <img className="marquee-image" src="/assets/images/payment/bkash.png" alt="payment option"/>
                  </li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/nagad.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/upay.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/rocket.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/bkash.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/nagad.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/upay.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/rocket.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/bkash.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/nagad.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/upay.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/rocket.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/bkash.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/nagad.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/upay.png" alt="payment option" /></li>
                  <li className="marquee-item"><img className="marquee-image" src="/assets/images/payment/rocket.png" alt="payment option" /></li>
                  <li className="marquee-item"><span className="" style={{display: 'inline-block'}}></span></li>
                  <li className="marquee-item"><span className="" style={{display: 'inline-block'}}></span></li>
                  <li className="marquee-item"><span className="" style={{display: 'inline-block'}}></span></li>
                  <li className="marquee-item"><span className="" style={{display: 'inline-block'}}></span></li>
                </ul>
            </marquee>
          </footer>
          <ul className="login-policy login-footer-link policy-link home-link">

            <li>
              <Link
                to="javascript:void(0)"
                style={{textDecoration:'none', color:'#000'}}
                onClick={() => {
                  handleContentToggle();
                  setSlug("about");
                }}
              >
                About us
              </Link>
            </li>
            <li>
              <Link
                to="javascript:void(0)"
                style={{textDecoration:'none', color:'#000'}}
                onClick={() => {
                  handleContentToggle();
                  setSlug("term");
                }}
              >
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link
                to="javascript:void(0)"
                style={{textDecoration:'none', color:'#000'}}
                onClick={() => {
                  handleContentToggle();
                  setSlug("kyc");
                }}
              >
                KYC
              </Link>
            </li>
            <li>
              <Link
                to="javascript:void(0)"
                style={{textDecoration:'none', color:'#000'}}
                onClick={() => {
                  handleContentToggle();
                  setSlug("privacy");
                }}
              >
                Privacy Policy
              </Link>
            </li>


            <li>
              <Link
                to="javascript:void(0)"
                style={{textDecoration:'none', color:'#000'}}
                onClick={() => {
                  handleContentToggle();
                  setSlug("rules");
                }}
              >
                Rules and Regulations
              </Link>
            </li>

            <li>
              <Link
                to="javascript:void(0)"
                style={{textDecoration:'none', color:'#000'}}
                onClick={() => {
                  handleContentToggle();
                  setSlug("responsible");
                }}
              >
                Responsible Gaming
              </Link>
            </li>
            {/* <li>
                        <Link
                          to="javascript:void(0)"
                          style={{textDecoration:'none', color:'#000'}}
                          onClick={() => {
                            handleContentToggle();
                            setSlug("rules");
                          }}
                        >
                          Underage Gaming Policy
                        </Link>
                      </li> */}

            {/* <li>
                        <a href="#">Self-Exclusion Policy</a>
                      </li> */}

          </ul>



          <div className="extra-wrap">
            <div id="powerWrap" className="power-wrap-b" style={{ display: "block" }}>
              <span>Powered by</span>
              <img src="https://tsports.live/assets/images/home/transparent.gif      " />
            </div>
            <div style={{ position: 'relative', paddingBottom: '20px' }}>
              <img src="/app-download.png" alt="" />
              <span style={{ position: 'absolute', bottom: '0', left: '10%', fontSize: '12px' }}>v1.11 - 2022-03-23 - 3.1MB</span>
            </div>
          </div>
        </div>
      </div>


      {content && (
        <div className="frame-wrap">
          <div className="news-wrap news-wrap-frame">
            {slug === "about" && <Aboutus />}
            {slug === "term" && <GeneralTerms />}
            {slug === "kyc" && <Kyc />}
            {slug === "privacy" && <PrivacyPolicy />}
            {slug === "rules" && <RulesRegulation />}
            {slug === "responsible" && <ResponsibleGaming />}

            <footer>
              <Link
                to="#"
                className="btn-send"
                onClick={() => {
                  handleContentToggle();
                  setSlug("");
                }}
              >
                CLOSE
              </Link>
            </footer>
          </div>
        </div>
      )}



    </>
  );
};

export default FooterSection;